import cookie from "react-cookies";
import { sessionStorageGetItem } from "../../DataServices/Utils";

export default function () {
/*     cookie.save('MerchantAuthPayout',"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJXYlRQYVhYRzA5Rnd3ZVNTODZHbmpIa09paHE0allCaSIsImV4cCI6MTY5NjkyMjM5NSwiaWF0IjoxNjg5MTQ2Mzk1fQ.ntcCsUY-yqfxVkArtP3mMKqEzrXePkojn60_F9sZ5jg")
    cookie.save('auth_merchant_id',"jh6D7SzHvp"); */
    if (sessionStorageGetItem('MerchantAuthPayout') === '' || sessionStorageGetItem('MerchantAuthPayout') === undefined || sessionStorageGetItem('MerchantAuthPayout') === null) {
        return false;
    } else {
        return true;
    }
}